<app-nav titulo="Informes" descripcion="Aquí podrá ver, todos los scorings que se hicieron y los datos obtenidos de los solicitantes.">
    <div class="reports">


        <div class="custom-scoring">
            <form class="form-step">
                <span class="section-title">Datos de las personas a evaluar</span>
                <div class="persona-line" *ngFor="let personaFG of personasControls; let i = index" [formGroup]="personaFG">
                    <mat-form-field class="garantor-form-field dni" appearance="outline">
                        <mat-label>DNI{{ personasControls.length > 1 ? ' persona ' + (i + 1) : '' }}</mat-label>
                        <input matInput formControlName="dni"
                               inputmode="numeric"
                               (keypress)="onDniKeyPress($event)">
                        <mat-error *ngIf="personaFG.controls.dni.hasError('required')">
                            Por favor ingrese el dni
                        </mat-error>
                    </mat-form-field>

                    <div class="sex-selector-local vertical">
                        <span class="label">Sexo</span>
                        <div class="selector">
                            <button mat-raised-button type="button" class="selector-button male"
                                [ngClass]="{'selected': personaFG.controls.sexo.value === 'M'}"
                                (click)="setSexo(i, 'M')">M</button>
                            <button mat-raised-button type="button" class="selector-button female"
                                [ngClass]="{'selected': personaFG.controls.sexo.value === 'F'}"
                                (click)="setSexo(i, 'F')">F</button>
                        </div>
                        <mat-error *ngIf="personaFG.controls.sexo.invalid && personaFG.controls.sexo.touched">
                            Por favor seleccione el sexo
                        </mat-error>
                    </div>

                    <button mat-icon-button matTooltip="Eliminar persona" class="delete-persona" color="accent"
                        *ngIf="i !== 0" (click)="removePersona(i)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>

                <div class="add-persona" (click)="addPersona()">
                    <mat-icon>add_circle</mat-icon>
                    Agregar persona
                </div>

                <div class="button">
                    <button mat-raised-button color="primary" class="garantor-button scoring-button" (click)="getScoring()">
                        <span class="add-button-label">Realizar scoring</span>
                    </button>
                </div>
            </form>
        </div>

        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="reports"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateReports($event)"
            (sortFn)="updateSort($event)"
            [menuButtons]="menuButtons"
        ></app-data-table>
    </div>
</app-nav>
